<template>
  <div class="catalog-switcher">
    <input
        type="checkbox"
        id="catalog-params-mapping-switcher"
        @change="mapParams"
    />
    <label for="catalog-params-mapping-switcher"
           class="catalog-switcher__link-wrap"
    >
      <span class="catalog-switcher__link switcher button"
      >
        <span class="switcher__inner"></span>
      </span>

      <span class="catalog-switcher__title button__line-text">
        Сопоставление параметров
      </span>
    </label>
  </div>
</template>

<script>
import {FilterManagerPool} from "../../filter/manager";
import {fieldsetMixin} from "../../filter/fieldset/fieldsetMixin";
  export default {
    name: "CatalogParamsMappingFieldset",
    mixins: [
      fieldsetMixin
    ],
    methods: {
      mapParams(e) {
        this.manager.submit(this.dataToSubmit(e));
      },
      dataToSubmit(e) {
        return {
          mappingParams: e.target.checked
        }
      }
    },
    mounted() {
      this.manager = FilterManagerPool.getManager(this.filterKey);
    }
  }
</script>